import { IconProps } from './interfaces';

export const IconVideoPlayButton = ({ className }: IconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" className={className}>
            <path d="M17.2431 9.60208C18.0764 10.0832 18.0764 11.286 17.2431 11.7671L5.99222 18.2628C5.15888 18.7439 4.11722 18.1425 4.11722 17.1803V4.18894C4.11722 3.22669 5.15888 2.62528 5.99222 3.10641L17.2431 9.60208Z" />
        </svg>
    );
};
